import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css';
import DEFINES from '@/defines';
import RMS_ICONS from '@/icons';

import './custom.styl';

Vue.use (Vuetify, {
  iconfont: 'mdi',
  rtl: false,
  icons: RMS_ICONS,
  breakpoint: {
    thresholds: {
      xs: 360,
    },
  },
  options: {
    customProperties: true,
  },
  theme: {
    primary: DEFINES.THEME.PLATFORM.COLORS.PRIMARY,
    secondary: DEFINES.THEME.PLATFORM.COLORS.SECONDARY,
    background: DEFINES.THEME.PLATFORM.COLORS.BACKGROUND,
    accent: '#028090',
    error: '#E53935',
    info: '#71BCF7',
    success: '#02C39A',
    warning: '#FF9F1C',
    greyDarken3: '#424242',
    green: '#6DCD01'
  },
});
